import type { PluginManifest } from "@d12labs/plugins/types";

export const manifest: PluginManifest = {
	name: "crm",
	label: "CRM",
	description:
		"Mini-CRM (contacts + deals) — sample plugin exercising FK relationships between domain tables and business email send.",
	version: "0.1.0",
	navItems: [{ label: "CRM", href: "/crm", icon: "Users" }],
};
